import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { SupportModalComponent } from '../support-modal/support-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/auth/auth.service';
import { FunnelService } from 'src/app/pages/new-service/services/funnel.service';
import { ExistingServiceByLicensePlateService } from 'src/app/pages/new-service/services/existing-service-by-license-plate.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit {
  isRotated = false;
  isDropdownOpen = false;
  isQuestionOpen = false;
  isSelected: boolean = false;
  isHovered: boolean = false;
  private userSubscription!: Subscription;
  userName = 'Test User';
  userEmail = 'test@gmail.com';
  userImg = '../../assets/icons/navbar/nav-user-icon.svg';
  // userImg = '../../assets/images/logo_Avisa_Servicios_Integrales.png';

  constructor(
    private readonly router: Router,
    private readonly userService: UserService,
    private readonly BsModalService: BsModalService,
    private readonly AuthService: AuthService,
    private readonly FunnelService: FunnelService,
    private readonly existingServicesService: ExistingServiceByLicensePlateService
  ) { }

  ngOnInit(): void {
    this.userSubscription = this.userService.getUserInfo().subscribe((user) => {
      if (user) {
        this.userName = user.name;
        this.userEmail = user.email;
        this.userImg = user.img;
      } else {
        this.userName = 'Guest User';
        this.userEmail = 'No Email Provided';
        this.userImg = '../../assets/icons/navbar/nav-user-icon.svg';
        // this.userImg = '../../assets/images/logo_Avisa_Servicios_Integrales.png';
      }
    });
  }

  logout() {
    this.AuthService.logout()
  }

  toggleDropdown(): void {
    if (this.isQuestionOpen) {
      this.isQuestionOpen = false;
      this.isSelected = false;
      this.isHovered = false;
    }
    this.isRotated = !this.isRotated;
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  toggleQuestion(): void {
    if (this.isRotated && this.isDropdownOpen) {
      this.isRotated = false;
      this.isDropdownOpen = false;
    }
    this.isQuestionOpen = !this.isQuestionOpen;
  }

  onHover(state: boolean): void {
    this.isHovered = state;
  }

  onSelect(): void {
    this.isSelected = !this.isSelected;
  }

  redirectHelp() {
    const urlHelp =
      'https://cafler.atlassian.net/wiki/external/ZjI5MWFlZDM2NGIyNDlhODkyNTM0NDFiODE0NmQ2MjA';
    window.open(urlHelp, '_blank');
  }

  redirectTutorials() {
    const urlTutorial =
      'https://cafler.atlassian.net/wiki/external/NThlZWJiYzNmMzg4NDJlMzgzNzQwMGQzZmI1MDNkYTU';
    window.open(urlTutorial, '_blank');
  }

  redirectSupport() {
    const urlSupport = '';
    window.open(urlSupport, '_blank');
  }

  checkSamePath(subSectionPath: string): boolean {
    const actualPath = this.router.url;
    const segments = actualPath.split('/');
    const lastSegment = segments[segments.length - 1];
    return lastSegment === subSectionPath;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    if (!targetElement.closest('.icon-container') && !targetElement.closest('.dropdown-help')) {
      this.isQuestionOpen = false;
      this.isSelected = false;
    }

    if (!targetElement.closest('.button-arrow') && !targetElement.closest('.dropdown')) {
      this.isDropdownOpen = false;
      this.isRotated = false;
    }
  }

  goToNewService() {
    this.FunnelService.cleanLocalStorage();
    this.existingServicesService.clear()
    this.router.navigate(['/new-service']);

    // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    //   this.router.navigate(['/new-service']);
    // });
  }

  openModal(event: MouseEvent): void {
    this.isQuestionOpen = false;
    this.isHovered = false;
    this.isSelected = false;
    event.stopPropagation();

    const config = {
      class: 'modal-class-template',
      backdrop: true,
      ignoreBackdropClick: false,
    };

    const BsModalRef = this.BsModalService.show(SupportModalComponent, config);


    // const dialogRef = this.dialog.open(SupportModalComponent, {
    //   width: '80%',
    //   maxWidth: '800px',
    //   panelClass: 'modal-dialog-centered',
    // });

    // dialogRef.afterClosed().subscribe((result) => {
    // });
  }
}
